export default __webpack_public_path__ + "static/media/3_Still.8fd16170.jpg";